import styled from "styled-components";
import { remCalc } from "utilities/styles";
import { accountLightGrey, dark, darkGrey } from "utilities/variables/colors";
import { aboveMedium } from "utilities/variables/media";

export const HeroBanner = styled.div`
  background-color: ${accountLightGrey};
  text-align: center;
  padding: ${remCalc(48)} ${remCalc(24)};

  @media ${aboveMedium} {
    padding: ${remCalc(80)} ${remCalc(24)};
  }
`;

export const HeroTitle = styled.h1`
  font-size: ${remCalc(28)};
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.2px;
  color: ${dark};
  margin: 0 0 ${remCalc(16)};

  @media ${aboveMedium} {
    font-size: ${remCalc(36)};
  }
`;

export const HeroDescription = styled.p`
  font-size: ${remCalc(16)};
  line-height: ${remCalc(26)};
  color: ${darkGrey};
  max-width: ${remCalc(600)};
  margin: 0 auto;
`;

export const ContentWrapper = styled.div`
  width: 100%;
  max-width: 560px;
  margin: 48px auto;
  padding: 0 16px;

  @media ${aboveMedium} {
    margin: 64px auto;
    padding: 0;
  }
`;

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 32px;
`;